import React from "react";
import {observer} from "mobx-react";
import {
    IFlightSearchControllerViewModel
} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import styled from "styled-components";
import {
    PsoUserOptionComponent
} from "../../territorial-continuity-regime/pso-user-option.component";
import {PsoUserOptionsEnum} from "../../../services/flight-search/flight-search-controller/pso.enums";
import {IPsoMarket} from "../../../services/stations/pso-market.interface";
import {useServices} from "../../../hooks/use-services.hook";


const UserOptionBox = styled(PsoUserOptionComponent)`
    background-color: inherit;
    border: none;
    padding: 0;
    width: fit-content;
`


interface SearchMaskPsoMarketUserOptionsInlineComponentProps {
    searchController: IFlightSearchControllerViewModel;
    psoMarket: IPsoMarket;
}

export const SearchMaskPsoMarketUserOptionsInlineComponent: React.FC<SearchMaskPsoMarketUserOptionsInlineComponentProps> = observer((props) => {
    const services = useServices();
    const searchController = props.searchController;


    const renderSeasonOption = () => {
        const activeSeasons = props.psoMarket.getActiveSeasons(services.time.currentDate);
        if(activeSeasons.length === 0) {
            return null;
        }

        return (
            <>
                {activeSeasons.map(season => (<UserOptionBox optionValue={season.getPsoUserOption()} searchController={searchController}/>))}
            </>

        );
    }

    return (
        <>
            <UserOptionBox optionValue={PsoUserOptionsEnum.Resident} searchController={searchController}/>
            {renderSeasonOption()}
        </>
    )
})